import { Search } from 'lucide-react'
import Input from '@/components/ui/Input'
import { cn } from '@/utils/cn'
import { useTranslation } from 'react-i18next'

export type FilterType = 'all' | 'revelation' | 'juz' | 'number'

interface SurahFiltersProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  filterType: FilterType
  onFilterChange: (filter: FilterType) => void
}

export default function SurahFilters({
  searchQuery,
  onSearchChange,
  filterType,
  onFilterChange,
}: SurahFiltersProps) {
  const { t } = useTranslation()

  const filters = [
    { id: 'all' as FilterType, label: t('quran.filters.all', 'الكل') },
    { id: 'revelation' as FilterType, label: t('quran.filters.revelation', 'ترتيب النزول') },
    { id: 'juz' as FilterType, label: t('quran.filters.juz', 'حسب الجزء') },
    { id: 'number' as FilterType, label: t('quran.filters.number', 'حسب الرقم') },
  ]

  return (
    <div className="space-y-4">
      {/* Search */}
      <div className="relative">
        <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500 w-5 h-5" />
        <Input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('quran.filters.searchPlaceholder', 'ابحث عن سورة...')}
          className="pr-10"
        />
      </div>

      {/* Filter Buttons */}
      <div className="flex flex-wrap gap-2">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              'px-4 py-2 rounded-lg text-sm font-medium transition-colors',
              filterType === filter.id
                ? 'bg-primary-600 dark:bg-primary-500 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'
            )}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  )
}

